export { base64StringFromByteArray } from './fromByteArray';
